@if (pagedApprovals$ | async; as approvals) {
  <div class="form-row">
    <div class="d-flex w-100 justify-content-end">
      <button type="button" class="btn btn-explain text-primary small" (click)="clearFilters()">Clear filters</button>
    </div>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-6 g-2 mb-3">
      <div class="col">
        <label class="sr-only" for="countryFilter">Select a country</label>
        <select class="form-select form-select-md" [formControl]="selectedCountry" id="countryFilter">
          <option value="">All Countries</option>
          @for (country of transferCredits.countries$ | async; track country) {
            <option [value]="country">{{country}}</option>
          }
        </select>
      </div>
      <div class="col">
        <label class="sr-only" for="institutionFilter">Select an institution</label>
        <select class="form-select form-select-md" [formControl]="selectedInstitution" id="institutionFilter">
          <option value="">All Institutions</option>
          @for (institution of transferCredits.institutions$ | async; track institution) {
            <option [value]="institution">{{institution}}</option>
          }
        </select>
      </div>
      <div class="col">
        <label class="sr-only" for="departmentFilter">Select a department</label>
        <select class="form-select form-select-md" [formControl]="selectedDept" id="departmentFilter">
          <option value="">All Departments</option>
          @for (dept of transferCredits.depts$ | async; track dept) {
            <option [value]="dept">{{dept}}</option>
          }
        </select>
      </div>
      <div class="col">
        <!-- Dropdown for selecting Core Courses -->
        <label class="sr-only" for="courseFilter">Select one or more core courses</label>
        <select class="form-select form-select-md" id="courseFilter" (change)="addArrayValue($event, selectedCoreCourses)">
          <option value="" selected disabled>Core Course</option>
          <!-- IMPORTANT:   This list is intentionally different from all the other host course lists and includes ECON 410.
          Per Brooke: "students can take either BUSI 402 or ECON 410 to fulfill a core requirement. 90% of students are doing BUSI 402"-->
          @for (item of profile.settings.transferCreditsCoreCourseFilterList; track item) {
            <option [value]="item" [disabled]="selectedCoreCourses?.value?.includes(item)">{{item}}</option>
          }
        </select>
        <!-- Pills for selected Core Courses -->
        @if (!!selectedCoreCourses?.value?.length) {
          @for (value of selectedCoreCourses.value; track value) {
            <span class="badge bg-primary me-1 mt-1">
              {{value}}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" aria-label="Remove"
              (click)="removeArrayValue(selectedCoreCourses, value)"></button>
            </span>
          }
        }
      </div>
      <div class="col">
        <!-- Dropdown for selecting General Education -->
        <label class="sr-only" for="genEdFilter">Select one or more general education codes</label>
        <select class="form-select form-select-md" id="genEdFilter" (change)="addArrayValue($event, selectedGenEds)">
          <option value="" selected disabled>General Education</option>
          @for (item of transferCredits.genEds$ | async; track item) {
            <option [value]="item" [disabled]="selectedGenEds?.value?.includes(item)">{{item}}</option>
          }
        </select>
        <!-- Pills for selected General Education -->
        @if (!!selectedGenEds?.value?.length) {
          @for (value of selectedGenEds.value; track value) {
            <span class="badge bg-success me-1 mt-1">
              {{value}}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" aria-label="Remove"
              (click)="removeArrayValue(selectedGenEds, value)"></button>
            </span>
          }
        }
      </div>
      <div class="col">
        <!-- Dropdown for selecting Area of Emphasis -->
        <label class="sr-only" for="aoeFilter">Select one or more area of emphasis</label>
        <select class="form-select form-select-md" id="aoeFilter" (change)="addArrayValue($event, selectedAoEs)">
          <option value="" selected disabled>Area of Emphasis</option>
          @for (item of transferCredits.areasOfEmphasis$ | async; track item) {
            <option [value]="item" [disabled]="selectedAoEs?.value?.includes(item)">{{item}}</option>
          }
        </select>
        <!-- Pills for selected Area of Emphasis -->
        @if (!!selectedAoEs?.value?.length) {
          @for (value of selectedAoEs.value; track value) {
            <span class="badge bg-success me-1 mt-1">
              {{value}}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" aria-label="Remove"
              (click)="removeArrayValue(selectedAoEs, value)"></button>
            </span>
          }
        }
      </div>
    </div>
    <!--  LIST OF COURSES  -->
    <div class="responsive-lister container-fluid mb-2">
      <div class="row d-none d-lg-flex">
        <div class="col fw-bold pe-1">Country</div>
        <div class="col-3 fw-bold px-1">Institution</div>
        <div class="col-3 fw-bold px-1">
          Course Name <button type="button" class="btn btn-sm course-name-search-btn"
            #courseNamePopover="ngbPopover"
            [ngbPopover]="courseNameSearchPopover"
            [autoClose]="false"
            placement="right"
            popoverClass="course-name-search-popover"
            [class.active]="courseNamePopover.isOpen()"
            [class.has-filter]="!!selectedCourseName.value"
            [attr.aria-expanded]="courseNamePopover.isOpen()"
            aria-haspopup="dialog"
            aria-label="Search course name"><i class="fas fa-search" aria-hidden="true"></i></button>
        </div>
        <div class="col fw-bold px-1">Course Number</div>
        <div class="col fw-bold px-1">UNC Course</div>
        <div class="icon-col fw-bold ps-1">GE</div>
      </div>
      @if (!!approvals?.length) {
        @for (course of approvals; track course.Id) {
          <div class="row course-data d-block d-lg-flex p-2 p-lg-0">
            <div class="col d-flex align-items-center px-1 ps-lg-2">
              <span class="fw-bold d-flex d-lg-none align-self-start me-2">Country</span>{{course.HostCountry}}
            </div>
            <div class="col-3 d-flex align-items-center px-1">
              <span class="fw-bold d-flex d-lg-none align-self-start me-2">Institution</span>{{course.HostProgram}}
            </div>
            <div class="col-3 d-flex align-items-center px-1">
              <span class="fw-bold d-flex d-lg-none text-nowrap align-self-start me-2">Course Name</span>
              <button type="button" (click)="onEditRequest(course.Id)"
                class="btn btn-sm btn-link text-start text-decoration-none text-break p-0">
                {{course.HostCourseName}}
              </button>
            </div>
            <div class="col d-flex align-items-center px-1">
              <span class="fw-bold d-flex d-lg-none align-self-start me-2">Course Number</span>{{course.HostCourseNumbers?.join(', ')}}
            </div>
            <div class="col d-flex align-items-center px-1">
              <span class="fw-bold d-flex d-lg-none align-self-start me-2">UNC Course</span>{{course.UncPrimaryCourseNumber}} ({{course.UncPrimaryCreditHours}})
            </div>
            <div class="icon-col d-flex align-items-center px-1 pe-lg-2">
              @if (!!course.GeneralEducation?.length) {
                <div class="d-flex d-lg-none"><span class="fw-bold align-self-start me-2">GE</span>{{course.GeneralEducation.join(', ')}}</div>
                <i class="fas fa-check-square text-success ge-icon d-none d-lg-flex" [ngbTooltip]="course.GeneralEducation.join(', ')"></i>
              }
            </div>
          </div>
        }
      }
      @if (!approvals?.length) {
        <div class="d-flex justify-content-center">No matches found.  Your filters might be a little too specific - try removing one or two to see more results.</div>
      }
    </div>
    <button class="btn btn-primary" (click)="onEditRequest(0)">Create New</button>
    <div class="pagination-controls text-center">
      <button class="btn btn-primary" (click)="previousPage()" [disabled]="currentPage$.value === 1">Previous</button>
      <span> Page {{currentPage$ | async}} of {{ totalPages$ | async }} </span>
      <button class="btn btn-primary" (click)="nextPage()" [disabled]="(currentPage$.value * pageSize) >= (filteredApprovals$ | async)?.length">Next</button>
    </div>
  </div>
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}

<ng-template #courseNameSearchPopover>
  <div class="position-relative">
    <input #courseNameSearchInput ngbAutofocus type="text" class="form-control form-control-sm pe-4" id="courseNameSearchInput"
      [formControl]="selectedCourseName"
      [ngbTypeahead]="searchCourseName"
      placeholder="Search course name..." />
    @if (selectedCourseName.value) {
      <button type="button" class="btn btn-sm btn-link text-secondary position-absolute top-50 end-0 translate-middle-y p-1"
        aria-label="Clear text" (click)="clearCourseName(); courseNameSearchInput.focus()">
        <i class="fas fa-times"></i>
      </button>
    }
  </div>
</ng-template>

